module.exports = __webpack_public_path__ + "89f4ec8d59368354dab37cc596b59db9.svg";